import { RegisterScoreTable } from './RegisterScoreTable';
export default RegisterScoreTable;
